// extracted by mini-css-extract-plugin
export default {"modalFooter":"modal-footer_modalFooter__AyGG9","repeat":"modal-footer_repeat__zLLoE"};